<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2023-02-06 15:57:00
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-06-07 14:41:00
-->
<template>
  <div class="innovative innovative-aneushape" ref="aneushape">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/m/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.aneushape.title')"></div>
    </div>
    <div class="p-t-50 p-b-10">
      <div class="p-l-30 p-r-30">
        <div class="innovative-item-title p-l-25" v-html="$t('product.aneushape.list[0].title')"></div>
      </div>
      <div class="p-t-28 p-l-15 p-r-15">
        <img class="wid100" :src="$t('product.aneushape.list[0].img')" alt="" srcset="">
      </div>
      <div class="p-l-30 p-r-30 textj">
        <p class="p-t-20 p-b-20" v-for="item, index in $t('product.aneushape.list[0].des')" :key="index" v-html="item"></p>
      </div>
    </div>
    <div>
      <div class="aneushape-characteristics">
        <div class="innovative-container">
          <div class="innovative-item-title" v-html="$t('product.aneushape.list[1].title')"></div>
          <div class="aneushape-characteristics-box">
            <div class="p-t-30 p-b-30" v-for="item, index in $t('product.aneushape.list[1].des')" :key="index">
              <div class="flex justify_content_center p-b-15 textc">
                <img class="aneushape-characteristics-img" :src="item.img" alt="" srcset="">
              </div>
              <div class="innovative-wrap-item-title fz-30 p-b-30 textc" v-html="item.title"></div>
              <div v-if="language == 'en'">
                <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
              </div>
              <div v-else class="textc">
                <p v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="aneushape-advantages innovative-container">
      <div class="innovative-item-title widauto ilblk p-r-200" v-html="$t('product.aneushape.list[2].title')"></div>
      <div class="innovative-aneushape-m-h">
        <img class="wid100" :src="$t('product.aneushape.list[2].m_img')" alt="" srcset="">
      </div>
    </div>
    <div class="innovative-container">
      <div class="p-t-30 article">
        <div class="innovative-item-title" v-html="$t('product.aneushape.article.title')"></div>
        <div class="p-t-15">
          <p class="p-t-15" v-for="item, index in $t('product.aneushape.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>

<style lang="less">
@import "~@/styles/m/products.less";
</style>

<style lang="less" scoped>
.m .innovative-aneushape {
  .aneushape-characteristics {
    background-image: url('~@/assets/images/innovate/AneuShape/m_2.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: top;
    padding: 20px 0;
    .aneushape-characteristics-box {
      background: #FFFFFF;
      box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
      padding: 50px 20px;
    }
    .aneushape-characteristics-img {
      height: 66px;
    }
  }
  .aneushape-advantages {
    background: #F8FBFF;
    border-radius: 8px;
    padding-bottom: 50px;
  }
  .innovative-aneushape-m-h {
    background: #FFFFFF;
    box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
    padding: 50px 15%;
  }
}
</style>
